import { useEffect, useState } from 'react';
import { postMediaUpdate } from './../utils/api';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const MediaModal = ({ open, onClose, accessToken, id, name: initialName, hidden, carouselMedia }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    setName(initialName || '');
  }, [open, initialName]);

  const save = () => {
    if (name) {
      postMediaUpdate(accessToken, id, name, hidden, carouselMedia)
      .then(() => {
        onClose();
      })
      .catch((error) => {
        console.warn(error);
        alert(error.toString());
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Change name</DialogTitle>
      <DialogContent>
        <TextField 
            autoFocus 
            margin="dense" 
            id="name" 
            label="Name" 
            type="text" 
            fullWidth 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={save} color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MediaModal;